import React, { memo } from 'react';
import NumericFormat from 'react-number-format';

import { useAccountNumbersField, useAccountNumbersValidation } from '@atlas/core';
import { Errors, Input, Label } from '@atlas/ui';

const AccountNumberFieldNumeric = ({ fieldIndex, hint, name, readOnly }) => {
  const { errors, isActive, isError, isTouched, label, onBlur, onChange, onFocus, value } =
    useAccountNumbersField({
      fieldIndex,
      name,
    });

  const handlePaste = e => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData('text');
    const numericValue = pastedText.replace(/[^\d]/g, '');
    onChange({ target: { value: numericValue } });
  };

  useAccountNumbersValidation({ fieldIndex, isTouched, name });

  return (
    <div className="account-number-form__inner required">
      <NumericFormat
        active={isActive}
        allowLeadingZeros
        allowNegative={false}
        className="account-numbers-input"
        customInput={Input}
        decimalScale={0}
        disabled={readOnly}
        error={isError}
        inputMode="numeric"
        label={label}
        onBlur={onBlur}
        onChange={onChange}
        onFocus={onFocus}
        onPaste={handlePaste}
        value={value}
      />

      {isError ? (
        <Errors errors={errors.map(({ message, params }) => ({ message, params }))} />
      ) : (
        <Label className="hint" message={hint} />
      )}
    </div>
  );
};

export default memo(AccountNumberFieldNumeric);
